export default {"src":"/_next/static/media/si.445c3f05.svg","height":59,"width":53};